module.exports = __webpack_public_path__ + "img/polygon_large.78775a05.svg";